'use client'

import Lottie from 'lottie-react'
import { CSSProperties } from 'react'

interface Props {
  animationData: object
  className?: string
  style?: CSSProperties
}

export default function OurAppsLottie({ animationData, className, style }: Props) {
  return (
    <div className={className} style={style}>
      <Lottie
        animationData={animationData}
        loop
        autoplay
      />
    </div>
  )
}